import React from "react"

import Layout from '../components/layout'
import SEO from '../components/seo'

class AboutUs extends React.Component {
  render() {
    const siteTitle = 'About Us';

    return (
      <Layout location={this.props.location} title={siteTitle}>
        <SEO title="About Us" />
        <h2>Mission</h2>
        <div>Promote transparency and accountability in government by empowering citizens to interact with campaign finance and civic data through easy-to-use visual and analytic tools.</div>
        <br/>
        <h2>Vision</h2>
        <div>Political Hack will be a resource that turns every citizen into a well-informed, political watchdog capable of doing their own data-backed investigation. We will be a leader in data manipulation tools and frameworks designed for everyday people. Political Hack will also be known as an organization for holding officials accountable through transparency and citizen-focused oversight.</div>
      </Layout>
    );
  }
}

export default AboutUs
